import apiClient from '@u/apiClient'
import router from '@/router'
import store from '@/store'

import WorkTaskActions from './work_task/actions'
import WorkAttachmentsActions from './work_attachments/actions'

let base_errors = { deceased: {}, events: [] }
export default {
  ...WorkTaskActions,
  ...WorkAttachmentsActions,

  //#region fetch

  /** Columns and filters (status, customers…) of the work list. */
  async fetchWorkIndexMetadata({ commit }) {
    await apiClient
      .get('api/work/index-metadata')
      .then(async (response) => {
        await commit('setWorkMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchWorkIndexMetadata', reason)
      })
  },

  /** Works only: the metadata comes from fetchWorkIndexMetadata. */
  // A request aborted through `payload.signal` (the page switched list)
  // commits nothing.
  fetchWorkList({ commit }, payload = {}) {
    return apiClient
      .get('api/work', {
        params: payload.filters ?? {},
        signal: payload.signal
      })
      .then((response) => {
        commit('setWorkList', response.data.works)
      })
      .catch((reason) => {
        if (reason?.code === 'ERR_CANCELED') return
        console.error('fetchWorkList', reason)
      })
  },

  async fetchArchivedWorkList({ dispatch }, payload) {
    await dispatch('fetchWorkList', { filters: { status: [payload.status] } })
  },

  async fetchWorkByID({ commit }, id) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/work/${id}`)
      .then(async (response) => {
        if (response.status === 200) {
          // Metadata first: the tabs render as soon as the work matches
          // the route and read their options from it.
          await commit('setWorkMetadata', response.data.metadata)
          await commit('setWork', response.data.work)
          await commit('auth/setErrors', base_errors, { root: true })
        }
      })
      .catch(async (reason) => {
        await console.error('fetchWorkByID', reason)
      })
  },

  async fetchNewWork({ commit }) {
    commit('setWork', { deceased: {}, work_items: [] })
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/model/new?model=work')
      .then(async (response) => {
        await commit('auth/setErrors', base_errors, { root: true })
        await commit('setWork', {
          ...response.data.work,
          deceased: {},
          events: []
        })
        await commit('setWorkMetadata', response.data.metadata)
        await commit('replaceContact')
      })
      .catch(async (reason) => {
        await console.error('fetchNewWork', reason)
      })
  },

  async fetchWorkActivities({ commit }, payload) {
    commit('setWorkActivities', [])
    await apiClient
      .get(`api/work/fetch-activities/${payload.work_id}`)
      .then(async (response) => {
        commit('setWorkActivities', response.data.activities)
      })
      .catch(async (reason) => {
        console.error('fetchWorkActivities', reason)
      })
  },
  //#endregion

  //#region store

  storeNewWork({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient.post('api/work', payload.form_data).then((response) => {
      router.push({
        name:
          store.getters['auth/getAuthRole'] === 'customer-user'
            ? 'work_form_edit_route'
            : 'work_form_event_list_route',
        params: { id: response.data.data.id }
      })
      return response.data
    })
  },

  //#endregion

  //#region update

  updateWorkStatus({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .put(`api/work/${payload.work_id}/status`, payload.form_data)
      .then((response) => {
        commit('auth/setErrors', {}, { root: true })
        commit('setWork', response.data.data)
        return response.data
      })
  },

  updateWork({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .put(`api/work/${payload.form_data.id}`, payload.form_data.work)
      .then((response) => {
        commit('setWork', response.data.work)
        return response.data
      })
  },

  //#endregion

  //#region delete
  // The response carries the unfiltered list: the page refetches its own.
  deleteWorkById(_, payload) {
    return apiClient
      .delete(`api/work/${payload.work_id}`)
      .then((response) => response.data)
  },

  undoDeleteWorkById(_, payload) {
    return apiClient
      .get(`api/work/undo-delete/${payload.work_id}`)
      .then((response) => response.data)
  }

  //#endregion
}
